import React, { useState } from "react";
import { Link } from "react-router-dom";

/* ================= SERVICES ICONS ================= */
import AutoIcon from "../../assets/icons/service-icons/injury.png";
import BodyIcon from "../../assets/icons/service-icons/kidney.png";
import CardiacIcon from "../../assets/icons/service-icons/cardiac.png";
import MskIcon from "../../assets/icons/service-icons/bones.png";
import NeuroIcon from "../../assets/icons/service-icons/brain.png";
import OncologyIcon from "../../assets/icons/service-icons/oncology.png";
import VascularIcon from "../../assets/icons/service-icons/vascular.png";
import WomenIcon from "../../assets/icons/service-icons/women.png";

import MammographyIcon from "../../assets/icons/service-icons/mammogram.png";
import NuclearIcon from "../../assets/icons/service-icons/Nuclear-Medicine.png";
import XrayIcon from "../../assets/icons/service-icons/x-ray.png";
import EchoIcon from "../../assets/icons/service-icons/echocardiography.png";
import UltrasoundIcon from "../../assets/icons/service-icons/ultrasound.png";
import MRIIcon from "../../assets/icons/service-icons/new_mri_128.png";
import CtIcon from "../../assets/icons/service-icons/openCT.png";
import DexaIcon from "../../assets/icons/service-icons/DEXA.png";
import PetCtIcon from "../../assets/icons/service-icons/ct-scan.png";
import ProstateIcon from "../../assets/icons/service-icons/prostrate.png";

/* ================= SERVICES MENU DATA ================= */
const servicesMegaMenu = {
  Subspecialties: [
    { name: "Auto/Personal Injury Imaging", icon: AutoIcon, },
    { name: "Body Imaging", icon: BodyIcon,  },
    { name: "Cardiothoracic Imaging", icon: CardiacIcon, },
    { name: "Musculoskeletal Imaging", icon: MskIcon, },
    { name: "Neurological Imaging", icon: NeuroIcon,  },
    { name: "Oncology Imaging", icon: OncologyIcon, },
    { name: "Prostate Imaging", icon: ProstateIcon, },
    { name: "Vascular Imaging", icon: VascularIcon, },
    { name: "Women’s Imaging", icon: WomenIcon, },
  ],

  tests: [
    { name: "2D/3D Mammography", icon: MammographyIcon,  },
    { name: "Cardiac/General Nuclear Medicine", icon: NuclearIcon, },
    { name: "Digital X-Ray", icon: XrayIcon,  },
    { name: "Echocardiography", icon: EchoIcon, },
    { name: "General/Vascular Ultrasound", icon: UltrasoundIcon,},
    { name: "High-Field/Open MRI", icon: MRIIcon,  },
    { name: "Low Dose 160-Slice Open CT", icon: CtIcon,  },
    { name: "Osteoporosis DEXA Scan", icon: DexaIcon,  },
    { name: "PET/CT", icon: PetCtIcon, },
  ],
};


/* ================= SERVICES LIST ================= */
const ServicesList = () => {
  const [activeTab, setActiveTab] = useState("Subspecialties");

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 text-center">
      {/* Tabs */}
      <div className="flex justify-around sm:justify-center sm:space-x-6 lg:space-x-24 border-b border-[#bf9c5e] mb-6 sm:mb-10">
        {Object.keys(servicesMegaMenu).map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`py-2 text-base sm:text-lg font-semibold uppercase tracking-wide ${
              activeTab === tab
                ? "text-[#bf9c5e] border-b-4 border-[#bf9c5e]"
                : "text-[#cccccc] "
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Services Grid */}
 <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 sm:gap-8 lg:gap-10">
  {[...servicesMegaMenu[activeTab]]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((item) => (
      <Link
        key={item.name}
        to={item.link}
        className="flex flex-col items-center hover:scale-105 transition-transform"
      >
        <img
          src={item.icon}
          alt={item.name}
          className="w-full h-16 sm:h-20 object-contain mb-2"
        />
        <div className="text-xs sm:text-sm font-bold text-[#bf9c5e] uppercase text-center">
          {item.name}
        </div>
      </Link>
    ))}
</div>
    </div>
  );
};

export default ServicesList;
